import { render } from "./ManagedImage.vue?vue&type=template&id=1652562e"
import script from "./ManagedImage.vue?vue&type=script&lang=js"
export * from "./ManagedImage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__